import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/business/layout/about')({
  component: About,
})

function About() {
  return (
    <div className="p-2">
      <h3>Welcome dawdawdHomde!</h3>
    </div>
  )
}
